// extracted by mini-css-extract-plugin
export default {"Chevrons":"Chevrons_Chevrons__w8acr","swing-in":"Chevrons_swing-in__xanEl"};